<template>
  <flight-bookings-list :filters="query" :page-size="20" />
</template>

<script>
import FlightBookingsList from './List.vue'

export default {
  name: 'FlightBookingsCancelled',
  components: { FlightBookingsList },
  props: {
    filters: { type: Object, default: () => ({}) }
  },
  computed: {
    query() {
      return { ...this.filters, status: 'cancelled' }
    }
  }
}
</script>
